$(() => {
  function addVimeoThumbToDom(mediaObject, item) {
    const thumbSource = mediaObject[0].thumbnail_large;
    $(item).css('background-image', `url(${thumbSource})`);
  }

  function getVideoThumb(id, item) {
    $.ajax({
      type: 'GET',
      url: `http://vimeo.com/api/v2/video/${id}.json`,
      jsonp: 'callback',
      dataType: 'jsonp',
      success: (data) => {
        addVimeoThumbToDom(data, item);
      }
    });
  }

  function addYouTubeThumbToDom(id, item) {
    const thumbSource = `http://img.youtube.com/vi/${id}/0.jpg`;
    $(item).css('background-image', `url(${thumbSource})`);
  }

  const videos = $('.media-item');

  $.each(videos, function(i, val) {
    const videoType = $(this).data('videotype');
    const videoId = $(val).data('videoid');
    if (videoType === 'vimeo') {
      getVideoThumb(videoId, this);
    } else {
      addYouTubeThumbToDom(videoId, this);
    }

  });

  videos.on('click', function(e) {
    let videourl;
    const videoId = $(this).data('videoid');
    const videoType = $(this).data('videotype');
    const vimeoUrl = `http://player.vimeo.com/video/${videoId}?autoplay=1&title=0&byline=0&portrait=0&quality=1080p`;
    const youtubeUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&controls=0&fs=0&modestbranding=1&showinfo=0&vq=hd1080`;

    if (videoType === 'vimeo') {
      videourl = vimeoUrl;
    } else {
      videourl = youtubeUrl;
    }
    const iframe = `<iframe src="${videourl}" id="lighbox-video" frameborder='0' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>`;

    $('.embed-container iframe').attr('src', videourl);
    $('html, body').animate({ scrollTop: 0 }, 'slow');

  });

  const footerMedia = $('.footer-tile__media');

  function getFooterThumbnail() {
    const videoType = footerMedia.data('videotype');
    const videoId = footerMedia.data('videoid');
    if (videoType === 'vimeo') {
      getVideoThumb(videoId, footerMedia);
    } else {
      addYouTubeThumbToDom(videoId, footerMedia);
    }
  }

  if (footerMedia.length > 0) {
    getFooterThumbnail();
  }

});
